import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Case } from "../_types/case";
import { firstValueFrom, Observable } from "rxjs";
import { ParamsBuilder } from "src/app/core/jsonapi/params/params-builder";
import { IParamsCollection } from "src/app/core/jsonapi/interfaces/params-collection";
import { ResponseCollection } from "src/app/core/jsonapi/responses/response-collection";
import { CaseServiceFilesPDFRequestDTO } from "../_types/case-file";
import * as saveAs from "file-saver";
import { User } from "../../users/_types/user";
import * as slug from "slug";
import { RelatedCases } from "../_types/related-cases";

@Injectable({
    providedIn: 'root',
})
export class CasesService extends Service<Case> {
    public override type = 'cases';
    public override url = 'attendance/cases';

    public getAll(userId:string, params: IParamsCollection = {}): Observable<ResponseCollection<Case>> {
        let url = this.getAPIUrl()+"/GetAll/" + userId;   
        
        url += ParamsBuilder.paramsCollectionToQueryString(params);
        
        return this.http.get<ResponseCollection<Case>>(url);
    }

    //rentabilidad del expediente frente al mínimo del contrato (ITSM #1838992)
    public getProfitability(caseId: string): Observable<{ percent: number, minPercent: number, isBelowMinimum: boolean }> {
        let url = this.getAPIUrl() + "/" + caseId + "/profitability";
        return this.http.get<{ percent: number, minPercent: number, isBelowMinimum: boolean }>(url);
    }

    public updateProcessor(processorId:string, casesIds: Array<string>): Observable<void> {
        let url = this.getAPIUrl()+"/" + processorId + '/casesProcessor';
        return this.http.post<void>(url, casesIds);
    }

    //cambio masivo de estado. El estado destino va por código: el servidor valida la transición contra
    //MassiveStateTransitions, así que no acepta un estado cualquiera.
    public updateCasesState(toStateCode:string, casesIds: Array<string>): Observable<any> {
        let url = this.getAPIUrl()+"/casesState/" + toStateCode;
        return this.http.post<any>(url, casesIds);
    }

    public search(search: any, full: boolean = false, sortByCaseNumber: boolean = false) {        
        //let url = this.getAPIUrl()+"/Search/"+encodeURIComponent(search);
        
        let url = this.getAPIUrl()+"/Search";
        return this.http.post<ResponseCollection<Case>>(url, {search:search, full: full, sortByCaseNumber: sortByCaseNumber});
    }   
    
    public distanceToCityCenter(id:string) : Observable<any> {
        let url = this.getAPIUrl()+"/"+id+"/citycenterdistance";
        return this.http.get<ResponseCollection<Case>>(url);
    }
    

    public exportCasePhotos(request: CaseServiceFilesPDFRequestDTO) : Promise<Blob>{
         let url = this.getAPIUrl()+"/"+request.caseId+"/pdf/"+request.templateId+ "/photo";
         return new Promise(async resolve => {
             this.http.post(url, request, { responseType: 'blob' }).subscribe((response: Blob) => {
              resolve(response);
                    
            });
        });
    }

    public updateCaseServiceTypes(caseId:string, servicesTypesIds: Array<string>): Observable<void> {
        let url = this.getAPIUrl()+"/" + caseId + '/updateCaseServiceTypes';    
        return this.http.post<void>(url, servicesTypesIds);
    }

    public updatePresence(id:string): Observable<User> {
        let url = this.getAPIUrl()+"/" + id + '/presence';   
        this.loaderService.skipRequest(url); 
        return this.http.put<User>(url, null);
    }

    public updateNotificationNumbers(id:string): Observable<any> {
        let url = this.getAPIUrl()+"/" + id + '/update-notification-numbers';   
        return this.http.get<any>(url);
    }

    public resume(id:string): Observable<any> {
        let url = this.getAPIUrl()+"/" + id + '/resume';   
        return this.http.get<any>(url);
    }

    //El criterio con el que dos expedientes se consideran relacionados se configura por empresa, asi que
    //lo resuelve el backend: aqui solo se pide el resultado.
    public getRelatedCases(caseId:string): Observable<RelatedCases>
    {
        let url = this.getAPIUrl()+ "/" + caseId + '/RelatedCases';
        return this.http.get<RelatedCases>(url);
    }


    public exportCasePhotosZIP(caseId: string, fileName: string, caseServiceId?: string) {
        let url = this.getAPIUrl()+"/"+caseId+"/zip/" + (caseServiceId?caseServiceId:'');
        return this.http.get(url,  { responseType: 'blob' }).subscribe((response: Blob) => {
            saveAs(response, (fileName!=null?slug(fileName)+'.zip':'archivos.zip'));
        });
    }

    public caseSameNumberAndContract(caseNumber: string, contractId: string, caseId?: string): Observable<boolean> {
        return this.http.get<boolean>(this.getAPIUrl() + "/" + contractId + "/CaseSameNumberAndContract/" + (caseId ? caseId : ''), { params: { caseNumber } });
    };
}
